import React, { memo, useCallback, useEffect, useState } from "react";
import { Spinner, UncontrolledTooltip } from "reactstrap";
import "./style.scss";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { downloadAttachmentStart, downloadAttachmentEnd } from "../../../store/attachmentsInteraction/actions";
import { showToast } from "../../../Libs/CustomMethods/showToast";


function AttachmentItemComponent({ type, data, active, onClick }) {
  const { file_name: fileName, file_url: fileUrl, mime_type: mimeType} = data?.files || {};
  const { created_at, updated_at, id } = data || {};
  const [loading, setLoading] = useState(false);
  const isDownloading = useSelector(state => state?.AttachmentsInteraction.downloadAttachment);
  const dispatch = useDispatch();
  
  const { t } = useTranslation();

  const notInAnalise = ['new', 'sent', 'requested'];
  const activeUpated = !notInAnalise.includes(type);
  const createdAt = created_at && new Date(created_at).toLocaleDateString();
  const updatedAt = updated_at && new Date(updated_at).toLocaleDateString();
  const aliasName = fileName?.split("@")?.[1] || fileName;

  const handleDownload = async () => {
    try {
      dispatch(downloadAttachmentStart({}))
      setLoading(true)

      const token = JSON.parse(localStorage.getItem("authUser"));
      const config = {
        responseType: 'arraybuffer',
        headers: {
          Authorization: token.Authorization, 
          'Content-Type': mimeType,
          'Accept': mimeType
        }
      }
      const response = await axios.post(`${process.env.REACT_APP_MESSAGES_API_URL}/download`, { fileUrl, fileName: aliasName }, config)
      if(response.status !== 200) {
        throw new Error("Error downloading attachment")
      }
      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName); // Replace with the desired filename
      document.body.appendChild(link);
      link.click();
      link.remove();
      showToast(t('Attachment downloaded successfully'), "success");
    } catch (error) {
      showToast(t(error.message), "error")
    } finally {
      setLoading(false)
      dispatch(downloadAttachmentEnd({}))
    }
  }

  const handleClick = useCallback(() => {
    onClick?.(data);
  }, [data, onClick]);

  return (
    <div
      className={`attachment-item ${active && "active"}`}
      type={type}
      onClick={handleClick}
    >
      <div className="icon">
        <i className="bx bx-file" aria-hidden="true"></i>
      </div>
      <div className="info">
        <h6 id={`file-name-${id}`}>{aliasName ?? data?.note}</h6>
        <div className="d-flex justify-content-between w-100">
          <p id={`created-at-${id}`}>
            <i className="bx bx-cloud-download" />
            {createdAt || "--/--/---"}
          </p>          
          
          {
            activeUpated ? (<>
              <p id={`updated-at-${id}`}>
                <i className="bx bx-check" />
                { updatedAt || "--/--/---"}
              </p>              
            </>) : null
          }              
                     
          
        </div>
      </div>
      <div className="action">
        {
          loading ? (
            <Spinner size="sm" animation="border" style={{cursor: "not-allowed"}}/>
          ) : (
            <button className="btn" onClick={handleDownload} disabled={isDownloading}>
              {fileUrl && <i className="bx bx-download" />}
            </button>
          )
        }
      </div>

      <UncontrolledTooltip placement="right" target={`file-name-${id}`}>
        {aliasName ?? data?.note}
      </UncontrolledTooltip>
      <UncontrolledTooltip placement="right" target={`created-at-${id}`}>
        {t("Shipping date")}
      </UncontrolledTooltip>
      {
        activeUpated ? (<>
        <UncontrolledTooltip placement="right" target={`updated-at-${id}`}>
          {t("Analysis date")}
        </UncontrolledTooltip>        
        </>) : null
      }
      
    </div>
  );
}

export default memo(AttachmentItemComponent);
